import { register } from "@rill/loader";

register(
  {
    name: "tdeeOverride",
    meta: ["no-bust", "nutrition-tdee-override"],
    ttl: "2 hours",
  },
  async ({ api }, { proxyAthlete }) => {
    const res = await api("nutrition-tdee-override", {
      query: { proxyAthlete },
    });
    const { override } = await res.json();

    return override ?? null;
  }
);
